import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';
import { MDCMenuSurface, Corner } from '@material/menu-surface';

Component('tr-project-todo-filter', {
  mixins: [eventListenerMixin],

  properties: {
    openInSlide: {
      type: Boolean,
      default: false,
    },

    filtered: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.filterForm = this.querySelector('form.todo-filter-form');
    this.formInputs = this.filterForm.querySelector('.filter-condition-inputs');
    this.formInputsHTML = this.formInputs.innerHTML;

    this.triggerButton = this.querySelector('.filter-toggle-button');
    this.listenTo(this.triggerButton, 'click', this.toggleFilterForm.bind(this));

    this.listenTo(this.querySelector('.cancel-button'), 'click', () => {
      this.cancelFilter();
    });
  },

  ready() {
    if (this.openInSlide) {
      this.initSlide();
    } else {
      this.initMenuSurface();
    }
  },

  initMenuSurface() {
    const menuSurface = this.querySelector('.mdc-menu-surface');
    if (!menuSurface) return;

    this.mdcMenuSurface = new MDCMenuSurface(menuSurface);
    this.mdcMenuSurface.setMenuSurfaceAnchorElement(this);
    this.mdcMenuSurface.setAnchorCorner(Corner.BOTTOM_LEFT);

    this.listenTo(this.mdcMenuSurface, {
      'MDCMenuSurface:opened': this.handleMenuSurfaceOpened.bind(this),
      'MDCMenuSurface:closed': this.handleMenuSurfaceClosed.bind(this),
    });

    // eslint-disable-next-line no-underscore-dangle
    this.mdcMenuSurface.foundation_.handleBodyClick = (event) => {
      if (!this.contains(event.target) && closest(event.target, 'body > .wrapper')) {
        this.mdcMenuSurface.open = false;
      }
    };
  },

  initSlide() {
    this.slide = this.querySelector('tr-slide');

    this.listenTo(this.slide, 'tr-slide:closed', this.handleSlideClosed.bind(this));
    this.listenTo(document, 'click', this.closeSlideOnClickOutside.bind(this));
  },

  toggleFilterForm() {
    if (this.openInSlide) {
      if (this.slide.isOpen()) {
        this.slide.close();
      } else {
        this.slide.open();
      }
    } else {
      this.mdcMenuSurface.open = !this.mdcMenuSurface.open;
    }
  },

  cancelFilter() {
    if (this.openInSlide) {
      this.slide.close({ action: 'cancel' });
    } else {
      this.skipFormAutoSubmit = true;
      this.mdcMenuSurface.open = false;
    }
  },

  resetFormInputs() {
    if (this.formInputsHTML && this.formInputs) {
      this.formInputs.innerHTML = this.formInputsHTML;
    }
  },

  handleMenuSurfaceOpened() {
    this.skipFormAutoSubmit = false;
    this.formValues = $(this.filterForm).serialize();

    [...this.querySelectorAll('[tao-id]')].forEach((component) => {
      if (typeof component.layout === 'function') {
        component.layout.call(component);
      }
    });
  },

  handleMenuSurfaceClosed() {
    if (this.skipFormAutoSubmit) {
      this.resetFormInputs();
    } else if (this.formValues !== $(this.filterForm).serialize()) {
      this.filterForm.dispatchEvent(new Event('submit', {
        bubbles: true,
        cancelable: true,
      }));
    }
  },

  handleSlideClosed(event) {
    if (event.detail.action === 'cancel') this.resetFormInputs();
  },

  closeSlideOnClickOutside(event) {
    if (!this.slide.isOpen()) return;

    if (!this.contains(event.target) && closest(event.target, 'body > .wrapper')) {
      this.cancelFilter();
    }
  },

  disconnected() {
    this.stopListening();
    if (this.mdcMenuSurface) this.mdcMenuSurface.destroy();
  },
});
